import styled, { keyframes } from "styled-components";
import { motion } from 'framer-motion';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// const flow = keyframes`
//   0% { stroke-dashoffset: 100; }
//   100% { stroke-dashoffset: 0; }
// `;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 120px 0px;
  background-color: #0A091A;
  background-image: 
    linear-gradient(rgba(133, 76, 230, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(133, 76, 230, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 80%;
    background: radial-gradient(circle, rgba(133, 76, 230, 0.1) 0%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  z-index: 1;
`;

export const BrandingHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
`;

export const LogoCircle = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  margin-bottom: 24px;
`;

export const LogoText = styled.div`
  font-family: 'Playfair Display', serif;
  font-size: 42px;
  color: #FFFFFF;
`;

export const Title = styled.h2`
  font-size: 56px;
  text-align: center;
  font-weight: 900;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: -0.02em;
  margin-bottom: 12px;
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  opacity: 0.7;
  margin-bottom: 60px;
`;

export const MetricsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 80px;
  width: 100%;
  margin-bottom: 100px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  @media (max-width: 768px) {
    gap: 30px;
    flex-wrap: wrap;
  }
`;

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MetricValue = styled.div`
  font-size: 36px;
  font-weight: 800;
  color: #FFFFFF;
`;

export const MetricLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.2em;
  margin-top: 4px;
`;

export const FunnelContainer = styled.div`
  position: relative;
  width: 100%;
  height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 960px) {
    height: auto;
    flex-direction: column;
    gap: 60px;
    padding-top: 40px;
  }
`;

export const SVGOverlay = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;

  @media (max-width: 960px) {
    display: none;
  }
`;

export const AnimatedLine = styled(motion.path)`
  stroke: ${({ theme }) => theme.primary + "40"};
  stroke-width: 0.6;
  fill: none;
`;

export const CenterPiece = styled.div`
  position: relative;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  padding: 8px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: -15px;
    left: -15px;
    right: -15px;
    bottom: -15px;
    border-radius: 50%;
    border: 1px dashed ${({ theme }) => theme.primary + "20"};
    animation: ${rotate} 80s linear infinite;
  }

  @media (max-width: 768px) {
    width: 240px;
    height: 240px;
  }
`;

export const CenterImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  opacity: 0.9;
`;

export const Node = styled.div`
  position: absolute;
  width: 300px;
  display: flex;
  flex-direction: column;
  z-index: 3;
  
  @media (max-width: 960px) {
    position: static;
    width: 100%;
    align-items: center;
    text-align: center;
  }
`;

export const IconCircle = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(133, 76, 230, 0.15);
  border: 1px solid rgba(133, 76, 230, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  color: #854CE6;
`;

export const NodeTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 6px;
`;

export const NodeDesc = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
`;

